import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Button } from 'react-bootstrap'

import * as actions from '../../../actions'
import { FORM_INGRESO_COMPLETO } from '../../../../../config/forms'
import CamposIngresoCompleto3 from
  '../../../components/iCompleto/CamposIngresoCompleto3'

class IngresoCompleto3 extends Component {
  componentDidMount () {
    const {
      impresora,
      numero,
      imprimirEtiquetaIngreso
    } = this.props
    imprimirEtiquetaIngreso(numero, impresora)
  }

  render () {
    const {
      handleSubmit,
      onPrev,
      formValues
    } = this.props

    return (
      <div>
        <form onSubmit={handleSubmit}>
          <h3>Impresión de comprobante</h3>
          <br />
          <hr />
          <CamposIngresoCompleto3 formValues={formValues} />
          <hr />
          <br />
          <Button
            type='button'
            onClick={() => onPrev()}
            size='lg'
            variant='outline-primary'
          >Atras</Button>{'  '}
          <Button
            type='submit'
            size='lg'
            variant='outline-primary'
          >Finalizar</Button>
        </form>
      </div>
    )
  };
};

const mapStateToProps = (state) => ({
  formValues: getFormValues(FORM_INGRESO_COMPLETO)(state),
  impresora: state.camionesIngreso.iCompletoImpresora,
  numero: state.camionesIngreso.iCompletoCpa.numero
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_INGRESO_COMPLETO,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})

export default withRedux(withReduxForm(IngresoCompleto3))
